export default "__VITE_ASSET__C6Qt7yBH__"